import React from "react";

export default function About() {
    return (
        <div data-testid="about-page" className="max-w-5xl mx-auto px-6 md:px-12 py-24">
            <div className="text-[11px] tracking-[0.4em] uppercase text-gold mb-3">About MBG</div>
            <h1 className="font-display text-5xl md:text-7xl tracking-tighter mb-10">A different kind of dealership.</h1>
            <div className="grid md:grid-cols-2 gap-12 items-start">
                <div className="space-y-6 text-[#33302C] leading-relaxed font-light text-lg">
                    <p>MBG was built for the kind of buyer who walks past the fluorescent-lit dealer lot. We treat every vehicle in our showroom as a private commission — vetted, documented, and prepared to a standard that matches the badge on its hood.</p>
                    <p>Beyond the showroom, we serve a community of professional tint installers and detail shops with curated film stocks, precision tools, and a wholesale program for serious partners.</p>
                </div>
                <div className="aspect-[4/5] overflow-hidden">
                    <img src="https://images.unsplash.com/photo-1686783578965-64d2025cd2c1?w=1400&q=80&auto=format&fit=crop" loading="lazy" decoding="async" alt="Luxury car interior" className="w-full h-full object-cover" />
                </div>
            </div>
            <div className="mt-24 grid sm:grid-cols-3 gap-6">
                {[
                    { k: "120+", v: "Vehicles Curated" },
                    { k: "12 Years", v: "Tint Industry" },
                    { k: "B2B Network", v: "Across the Region" },
                ].map(s => (
                    <div key={s.k} className="border border-[#E2D4C1] bg-charcoal-800 p-8">
                        <div className="font-display text-4xl text-gold">{s.k}</div>
                        <div className="text-[11px] tracking-[0.3em] uppercase text-[#6B645C] mt-2">{s.v}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
